import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Data } from '@pcmp/react-coworker-components';
import { ListViewItem } from '@ingka/list-view';
import globeIcon from '@ingka/ssr-icon/paths/globe';

import { SUPPORTED_LOCALES } from '@/lib/constants';
import { useAppConfig } from '@/redux/features/app-config/hooks';
import { useAppDispatch } from '@/redux/hooks';
import { setValue } from '@/redux/features/app-config/slice';

import styles from './index.module.css';

const { PillDropdown } = Data;

const LanguageSwitcher: FC = () => {
  const { t } = useTranslation();
  const [languageOpen, setLanguageOpen] = useState(false);
  const { locale: currentLocale } = useAppConfig();
  const dispatch = useAppDispatch();
  const changeLocale = (locale: string) => {
    dispatch(
      setValue({
        key: 'locale',
        value: locale,
      })
    );
  };

  return (
    <div data-testid="changeLanguageButton">
      <PillDropdown
        pill={{
          iconPosition: 'trailing',
          label: t(`locales.${currentLocale}`),
          size: 'small',
          ssrIcon: globeIcon,
        }}
        listBox={{
          className: 'mb-3 ' + styles['list-box'],
        }}
        position="top-left"
        open={languageOpen}
        onClick={() => setLanguageOpen(!languageOpen)}
        onClose={() => setLanguageOpen(false)}
      >
        <>
          {SUPPORTED_LOCALES.map((locale) => (
            <ListViewItem
              key={locale}
              data-testid={`locale-${locale}`}
              control="radiobutton"
              controlProps={{
                value: locale,
                checked: currentLocale === locale,
              }}
              showDivider={false}
              inset
              name="language"
              onChange={() => changeLocale(locale)}
              title={t(`locales.${locale}`) + ` (${locale})`}
            />
          ))}
        </>
      </PillDropdown>
    </div>
  );
};

export default LanguageSwitcher;
